// Règles :
//   - DEFAULT_PRICE_CACHE_PROVIDER_COLUMNS est la source unique de vérité pour les colonnes.
//     setPriceCacheProviderPreference, le tri et l'export s'y réfèrent ; ne pas dupliquer.
//   - order_by = clé de tri côté front (l'API renvoie la liste complète, sans tri ni pagination).

import { Column } from '../objects/column';
import { PriceCachePolicyForm } from '../objects/priceCacheProvider';
import {
    PriceCacheProviderListConfiguration,
    PriceCacheProviderListCriteria,
    PriceCacheProviderListFiltersCriteria
} from '../objects/priceCacheProviderList';

export const PRICE_CACHE_PROVIDER_MODULE = 'PRICE_CACHE_PROVIDER';

/** Clé de traduction d'un libellé de colonne : partagée par le thead, le configurateur et l'export */
export const priceCacheColumnLabel = (label: string): string => `price-cache.${label}`;

export const DEFAULT_PRICE_CACHE_PROVIDER_COLUMNS: Column[] = [
    { label: 'name',                field_name: 'NAME',                checked: true,  order_by: 'name',                fixed_width: false, last_updated: false },
    { label: 'code',                field_name: 'CODE',                checked: true,  order_by: 'code',                fixed_width: true,  last_updated: false },
    { label: 'policy',              field_name: 'POLICY',              checked: true,  order_by: 'policy',              fixed_width: true,  last_updated: false },
    { label: 'circuits',            field_name: 'CIRCUITS',            checked: true,  order_by: 'circuits',            fixed_width: true,  last_updated: false },
    { label: 'hotels',              field_name: 'HOTELS',              checked: true,  order_by: 'hotels',              fixed_width: true,  last_updated: false },
    { label: 'hotels-mapped',       field_name: 'HOTELS_MAPPED',       checked: true,  order_by: 'hotels_mapped',       fixed_width: true,  last_updated: false },
    { label: 'owners-with-account', field_name: 'OWNERS_WITH_ACCOUNT', checked: true,  order_by: 'owners_with_account', fixed_width: true,  last_updated: false },
    { label: 'daily-budget',        field_name: 'DAILY_BUDGET',        checked: false, order_by: 'daily_budget',        fixed_width: true,  last_updated: false },
    { label: 'stays-targeted',      field_name: 'STAYS_TARGETED',      checked: true,  order_by: 'stays_targeted',      fixed_width: true,  last_updated: false },
    { label: 'stays-fetched',       field_name: 'STAYS_FETCHED',       checked: true,  order_by: 'stays_fetched',       fixed_width: true,  last_updated: false },
    { label: 'stays-available',     field_name: 'STAYS_AVAILABLE',     checked: true,  order_by: 'stays_available',     fixed_width: true,  last_updated: false },
    { label: 'modified-date',       field_name: 'MODIFIED_DATE',       checked: false, order_by: 'modified_date',       fixed_width: true,  last_updated: false },
];

export const EMPTY_PRICE_CACHE_PROVIDER_FILTERS: PriceCacheProviderListFiltersCriteria = {
    policy_status: '',
};

export const EMPTY_PRICE_CACHE_PROVIDER_LIST_CRITERIA: PriceCacheProviderListCriteria = {
    limit: 25,
    page: 0,
    order_by: 'circuits',
    order: 'desc',
    search: '',
    filters: EMPTY_PRICE_CACHE_PROVIDER_FILTERS,
};

export const EMPTY_PRICE_CACHE_PROVIDER_LIST_CONFIGURATION: PriceCacheProviderListConfiguration = {
    columns: DEFAULT_PRICE_CACHE_PROVIDER_COLUMNS,
    preferences: [],
};

/** Valeurs par défaut du modèle PriceCachePolicy (vat-api) : pré-remplissage quand le fournisseur n'a pas encore de policy */
export const DEFAULT_PRICE_CACHE_POLICY_FORM: PriceCachePolicyForm = {
    enabled: false,
    max_requests_per_second: 1,
    daily_budget: 1000,
    window_start_hour: null,
    window_end_hour: null,
    daily_weeks: 6,
    weekly_months: 4,
    monthly_months: 12,
    occupancies: [[[30, 30]], [[30]]],
    batch_size: 20,
};

/** Bornes du serializer PriceCachePolicySerializer (vat-api) */
export const PRICE_CACHE_MAX_OCCUPANCIES = 4;
export const PRICE_CACHE_MAX_ROOMS = 10;
/** Bornes de saisie front (l'API accepte toute chambre non vide) */
export const PRICE_CACHE_MAX_ADULTS_PER_ROOM = 6;
export const PRICE_CACHE_MAX_CHILDREN_PER_ROOM = 4;
